import { Button } from 'components/button/Button'
import { PageTitle } from 'components/PageTitle'
import { SideLayout } from 'components/sideLayout/SideLayout'
import { StoreCart } from 'components/store/storeCart/StoreCart'
import { StoreWrapper } from 'components/store/storeContent/StoreContent'
import { StoreSite } from 'components/store/storeSite/StoreSite'
import { WizardProgressHeader } from 'components/wizard/wizardProgressHeader/WizardProgressHeader'
import { GetServerSideProps } from 'next'
import Router, { useRouter } from 'next/router'
import { useStoreCart } from 'utils/cart'
import { GET_STORE_WIZARD_HEADER } from 'utils/constants'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page() {
  const router = useRouter()
  const cart = useStoreCart()

  return (
    <SideLayout
      rightCss={{ boxShadow: 'var(--card-shadow)' }}
      right={
        <StoreCart>
          {cart.items && Object.values(cart.items).length > 0 && (
            <Button type="button" size="large" href="/wgs/checkout" data-testid="site-checkout">
              Continue to checkout
            </Button>
          )}
        </StoreCart>
      }
      header={
        <WizardProgressHeader
          steps={GET_STORE_WIZARD_HEADER()}
          currentStep={GET_STORE_WIZARD_HEADER()[0]?.value}
        />
      }
    >
      <PageTitle title="Select action" />
      <StoreWrapper>
        <StoreSite
          siteId={router.query.siteId as string}
          onClick={() => Router.push('/wgs/select')}
        />
      </StoreWrapper>
    </SideLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  return { props: { ...(await getIntlProps(ctx, 'device')) } }
}
